var freeShippingThresholdTimeout;
jQuery(document).ready(function(){
  jQuery(document.body).bind('beforeGetCart.ajaxCart', function(){
    clearTimeout(freeShippingThresholdTimeout);
    freeShippingThresholdTimeout = setTimeout(function(){
      updateCartThreshold();
    }, 300);
  });
});

function updateCartThreshold()
{
  jQuery.getJSON('/cart.js', function(cart) {
    //console.log(cart);
    //console.log(cart.items_subtotal_price);
    var cartThreshold = parseFloat(jQuery('#free-shipping-threshold').data('free-shipping-threshold'));
    var remainingAmount = cartThreshold - parseFloat(cart.items_subtotal_price);
    //console.log(remainingAmount+' = '+cartThreshold+' - '+parseInt(cart.items_subtotal_price));
    if(!isNaN(remainingAmount) && remainingAmount > 0)
    {  
      //console.log('a: '+ remainingAmount);
      jQuery('#free-shipping-threshold span').html(Shopify.formatMoney(remainingAmount) + ' away from free shipping!');
      var barPercentage = Math.round((cart.items_subtotal_price / cartThreshold) * 100);
      //console.log('barPercentage: Math.round('+ cart.items_subtotal_price + '/ '+cartThreshold+')');
      jQuery('#free-shipping-threshold .bar .fill').css({'width':barPercentage+'%'});
      jQuery('#free-shipping-threshold .bar').show();
    }
    else if(!isNaN(remainingAmount))
    {
      //console.log('b: '+ remainingAmount);
      jQuery('#free-shipping-threshold span').html('This order ships free!');
      jQuery('#free-shipping-threshold .bar .fill').css({'width':'100%'});
      jQuery('#free-shipping-threshold .bar').hide();
    }
    
    //console.log('--');
  });
}